module["exports"] = [
  "Nord",
  "Ost",
  "West",
  "Süd",
  "Neu",
  "Alt",
  "Bad"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/de/address/city_prefix.js
// module id = 445
// module chunks = 0